import * as React from "react";

import MasonryGrid, {
  type MasonryGridItem as FluidGridItem,
  type MasonryGridProps as FluidGridProps
} from "@common/controls/Grid/Masonry/component";

export { type FluidGridItem, type FluidGridProps };
const FluidGrid = <TItemProps extends {} = {}, TItem extends FluidGridItem = FluidGridItem>(
  props: FluidGridProps<TItemProps, TItem>
) => <MasonryGrid {...props} className="wsc_fluid_grid" containerClassName="wsc_fluid_grid_container" />;
export default FluidGrid;
